import axios from "@/apis/axios-client";

const ListSections = async () => {

  return await axios.client
    .get(
      "/api/section",
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log("Sections:", error);
      return error;
    });
};

const sectionApi = {
  List: ListSections,
};

export default sectionApi;